// Implements: F-IDN-026, F-IDN-027
/**
 * The address of an invitation (mockup v3 P3): what the Invitaciones page copies for a pending
 * invitation. The page it opens (`/invitacion/:token`) is P2's.
 */

export function invitationLink(token: string): string {
  return `${window.location.origin}/invitacion/${encodeURIComponent(token)}`;
}
